import React from "react";
import { useHistory } from "react-router-dom";
import { NoDataFound } from "../../../../components/no-data-found";
import { ItineraryPreviewPlaceholder } from "../../../../components/skeleton-placeholder";
import ItineraryListComponent from "../../../../components/itinerary-component";
import { useAuth } from "../../../../contexts/AuthProvider";

const ItineraryItem = ({ itineraryData, isLoading, mapRef }) => {
  const history = useHistory();
  const { currencyData } = useAuth();

  return (
    <>
      {isLoading ? (
        <ItineraryPreviewPlaceholder />
      ) : !itineraryData ? (
        <NoDataFound />
      ) : (
        <>
          <div className="d-flex align-items-center mb-2">
            <button
              type="button"
              className="btn btn-secondary-color btn-border-color btn-width-30 me-2"
              onClick={() => history.goBack()}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <h1 className="d-col-title">{itineraryData?.tour_name}</h1>
          </div>
          <p className="mt-3 txt-cost">
            Estimated cost:{" "}
            {Number(itineraryData?.estimated_Cost) > 0 ? currencyData?.currency + " " + Math.floor(itineraryData?.estimated_Cost) : "0"}
          </p>
          {itineraryData?.destinationCityDetails?.map((destinationitem, i) => {
            return (
              <div className="mt-3" key={i}>
                <h4 className="d-nav-tabs-title">
                  Destination City -{" "}
                  <b>{destinationitem?.destination_city?.city}</b>
                </h4>
                <div className="row">
                  {destinationitem?.itineraryDatys?.map((daysitem, d) => {
                    return (
                      <div className="mt-3 col-lg-4">
                        <ItineraryListComponent
                          key={daysitem._id}
                          destinationIndex={i}
                          daysData={daysitem}
                          itineraryData={itineraryData}
                          mapRef={mapRef}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default ItineraryItem;
